import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {RegisterPage} from "../register/register";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {InsuranceData, IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {LoginPage} from "../login/login";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import * as moment from "moment";
import {IntroInsuranceConfirmationPage} from "../intro-insurance-confirmation/intro-insurance-confirmation";

/**
 * Generated class for the IntroInsurranceValidationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-insurrance-validation',
  templateUrl: 'intro-insurrance-validation.html',
})
export class IntroInsurranceValidationPage {
  loginPage: any = LoginPage;
  errorVisible: boolean = false;
  errorFormatVisible: boolean = false;
  errorBirthDateVisible: boolean = false;
  aokIdErrorVisible: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public contentTranslation: ContentTranslationProvider, public introWizard: IntroWizardServiceProvider, public apiAuth: ApiAuthProvider) {
    if(!this.introWizard.insurance) {
      this.introWizard.insurance = new InsuranceData();
    }
  }

  validateDate() {
    this.errorBirthDateVisible = false;

    let now = moment();
    let date = moment(this.introWizard.insurance.birthDate, 'YYYY-MM-DD');
    console.log(now.diff(date, 'years'), this.introWizard.insurance.birthDate);
    if(now.diff(date, 'years') < 18) {
      this.errorBirthDateVisible = true;
      return false;
    }

  }

  validateFormat() {
    this.errorFormatVisible = false;
    if(!this.introWizard.freeOffer) {
      return true;
    }
    if(!this.introWizard.insurance.aokId.match(/^[A-Z]{1}[0-9]{9}$/)) {
      this.errorFormatVisible = true;
      return false;
    }
  }

  sendInquiry(item: object) {
    this.hideError();

    var keys = ['firstName', 'lastName', 'aokId', 'birthDate'];
    for(var k in keys) {
      if(!this.introWizard.insurance[keys[k]]) {
        this.errorVisible = true;
        console.log('show error');
        return false;
      }
    }

    let now = moment();
    let date = moment(this.introWizard.insurance.birthDate, 'YYYY-MM-DD');
    console.log(now.diff(date, 'years'), this.introWizard.insurance.birthDate);
    if(now.diff(date, 'years') < 18) {
      this.errorBirthDateVisible = true;
      return false;
    }

    if(this.introWizard.freeOffer && !this.introWizard.insurance.aokId.match(/^[A-Z]{1}[0-9]{9}$/)) {
      this.errorFormatVisible = true;
      return false;
    }


    if(!this.errorVisible && !this.errorFormatVisible && !this.errorBirthDateVisible) {
      if(!this.introWizard.freeOffer) {
        this.navCtrl.push(IntroInsuranceConfirmationPage);
        return ;
      }

      var loader = this.loadingCtrl.create();
      loader.present();
      this.apiAuth.validateInsuranceNumber(this.introWizard.insurance.aokId).then((res:boolean) => {
        loader.dismissAll();
        if(res) {
          this.navCtrl.push(IntroInsuranceConfirmationPage);
        } else {
          this.introWizard.insurance.aokId = '';
          this.aokIdErrorVisible = true;
        }
      })


      // this.navCtrl.push(RegisterPage)
    }
  }

  hideError() {
    this.errorVisible = false;
    this.aokIdErrorVisible = false;
    this.errorFormatVisible = false;
    this.errorBirthDateVisible = false;
  }
  showMoreInfo() {
    let prefix = 'Registration Insurance Validation Modal Why I need to provider data';
    if(!this.introWizard.freeOffer) {
      prefix = 'Registration Insurance Validation Modal Why I need to provider non aok data';
    }
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent(prefix+' title'),
      subTitle: this.contentTranslation.translateContent(prefix+' text'),
      buttons: [
        'OK',
        {
          text: '×',
          cssClass: 'close-button'
        }
      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/intro-insurrance-validation/intro-insurrance-validation.ts